import { React, useContext, useEffect, useState } from "react";

import "../../components/CSS/Home/Upcominglive.css";
import axios from "axios";
import swal from "sweetalert";
import moment from "moment";
import { DotsHorizontalIcon } from "@heroicons/react/solid";
import ReactShowMoreText from "react-show-more-text";
import { Markup } from "interweave";
import { Link } from "react-router-dom";
import noImage from "../../Assets/Images/settings/no-image.png";
import PostReaction from "../../Screen/Post/PostReaction";
import { useHistory } from "react-router-dom";
import { serverInfo } from "../../App";

export default function UpcomingLiveContent({ post }) {


  const { imageCdnUrl } = useContext(serverInfo);
  const [isAvaiable,setSlot]=useState(true);


  const history = useHistory();

  const [open, setOpen] = useState(false);

  const [data, setData] = useState({
    likes: post.react_number,
    updated: false,
  });

  const handleSubmit = (id) => {
    //e.preventDefault();
    if (!data.updated) {
      setData({ likes: data.likes + 1, updated: true });
    } else {
      setData({ likes: data.likes - 1, updated: false });
    }

    axios.get(`/api/submit_react/${id}`).then((res) => {
      if (res.data.status === 200) {
      } else {
        swal("Warning", "failed", "warning");
      }
    });
  };

  const bookingController = (slug) => {
    history.push({
      pathname: `/livechat/details/${slug}`,
    });
  };


  let todayDate = new Date();
  let endDate = new Date(moment(post?.reg_end_date));

  useEffect(() => {
    axios
      .get(`api/user/check-meetup/slot/${post?.event_id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setSlot(res.data.isAvailable);
        }

      });
  }, []);


  return (
    <>
      <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
        <div className="card PostCardBg ">
          <h2 className="accordion-header PostBack">
            <div className="d-flex justify-content-between">
              <div className="accordion-button-fx profile1-accordion-button PostBack  collapsed">
                <img
                  src={post.star?.image?imageCdnUrl + post.star?.image:noImage}
                  className="PostImgHome"
                  alt="star-profile"
                />
                <span className="mx-2 text-warning text-light">
                <Link
                    to={`/starprofile/${post.user_id}`}
                    className="link-starPorfile cp"
                  >
                    {post.star.first_name} {post.star.last_name}
                  </Link>
                  <br></br>
                  <small className="category-size-chat">
                    {moment(post.created_at).format("LT")}
                    {" | "}
                  </small>
                  <small className="category-size-chat">
                    {moment(post.created_at).format("LL")}
                  </small>
                </span>
              </div>
            </div>
          </h2>

          <h5 className="my-2 Enroll-a Enroll-text text-justify">
            {post?.title}
          </h5>

          <ReactShowMoreText
            lines={3}
            more={<span>See more</span>}
            less={<span>See less</span>}
            className="content-css my-2 Enroll-a Enroll-text py-2"
            anchorClass="my-anchor-css-class"
            //onClick={executeOnClick}
            expanded={false}
            truncatedEndingComponent={"... "}
          >
            <Markup content={post?.details}></Markup>
          </ReactShowMoreText>

          <div className="ViewPost">
            <div className=" card  border-0 containerPost">
              <img
                src={imageCdnUrl + post?.banner}
                alt={post?.banner}
              />
              <div className="centeredPost ">
                <div className="LeftTextPost col-md-8">
                  <div className=" text-light bottom-LeftPost text-start  fw-bold px-4 py-1">
                    Live Chat
                  </div>
                </div>

                {endDate.getTime() >= todayDate.getTime() && isAvaiable && (
                <div className="LeftTextPost col-md-4">
                  <div
                    onClick={() => bookingController(post?.event_id)}
                    className="link-starPorfile"
                  >
                
                    <button className="bottom-rightPost text-dark fw-bold AnimateBtn px-4 py-1">
                      <span className="pTd">Book Now</span>
                    </button>
                  </div>
                </div>
                )}
              </div>
              <div className="centeredPostV "></div>
            </div>

            <PostReaction post={post} />
          </div>
        </div>
      </div>
    </>
  );
}
